
import { computed, defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import UserAvatar from "@/components/UserAvatar.vue";
import Notice from "@/components/Notice.vue";
import { useRoute } from "vue-router";
import { translate } from "@/core/services/HelpersFun";
export default defineComponent({
  name: "kt-details",
  components: {
    UserAvatar,
    Notice,
  },
  setup() {
    const loading = ref(true);
    const list = ref();
    const pagination = ref();
    const page = ref(1);

    const route = useRoute();

    const endPoint = computed(() => {
      return route.path === `/management/cooperationInSales/${route.params.id}`
        ? `admin/sale-cooperation/${route.params.id}/users`
        : `/sale-cooperation/users?with_commission=true&page=${page.value}&user_id=${route.params.id}`;
    });

    const getList = () => {
      loading.value = true;
      ApiService.get(endPoint.value)
        .then(({ data }) => {
          loading.value = false;
          list.value = data.data.users;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    onMounted(() => {
      getList();
    });

    const handleCurrentChange = (val: number) => {
      page.value = val;
      getList();
    };

    return {
      list,
      loading,
      pagination,
      handleCurrentChange,
      translate,
    };
  },
});
